// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2H18V6.32718L22 5.88274V14H17V22H2V8.10496L6 7.66051V2ZM8 7.43829L16 6.5494V4H8V7.43829ZM6 10.998V13.002H8.00391V10.998H6ZM10 10.998V13.002H12.0039V10.998H10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 22H22V16H19V22Z"}}]};

const MuseumFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'museum-filled',
    ref,
    icon: element,
  },
));

MuseumFilledIcon.displayName = 'MuseumFilledIcon';

export default MuseumFilledIcon;
